import React from 'react';
import PropTypes from 'prop-types';
import { config } from 'utils/config';
import { getGoogleMapsURL } from 'utils/locations';
import { URL, ASSETS } from 'constants';
import Picture from 'components/Picture';

const PROTOCOL = `${window.location.protocol}//`;
const HOST = window.location.host;
const MAPPINHASHTABLE = {
  AIRPORT: `${PROTOCOL}${HOST}${ASSETS.GOOGLE_MAP_AIRPORT}`,
  CITY: `${PROTOCOL}${HOST}${ASSETS.GOOGLE_MAP_CITY}`,
  RAILROAD: `${PROTOCOL}${HOST}${ASSETS.GOOGLE_MAP_RAIL}`,
};

const BranchLocationMapView = ({ address, lat, long, locationType }) => {
  const handleClick = () => {
    const googleMapsLink = getGoogleMapsURL(address);
    window.open(googleMapsLink, '_blank');
  };

  const locationTypeUperCase = (locationType ?? '').toUpperCase();
  const markerIconPath = MAPPINHASHTABLE[locationTypeUperCase] || MAPPINHASHTABLE.CITY;

  const googleMapsApiKey = config.getGoogleMapsAPIKey();
  return (
    <Picture
      pictureClassName='branch-location-detail__picture'
      onClick={handleClick}
      srcMobile={URL.GOOGLE_MAPS_STATIC_CALL(googleMapsApiKey, markerIconPath, lat, long, '500', '400')}
      srcTablet={URL.GOOGLE_MAPS_STATIC_CALL(googleMapsApiKey, markerIconPath, lat, long, '400', '250')}
      src={URL.GOOGLE_MAPS_STATIC_CALL(googleMapsApiKey, markerIconPath, lat, long, '500', '300')}
    />
  );
};

BranchLocationMapView.propTypes = {
  address: PropTypes.string.isRequired,
  lat: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  long: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  locationType: PropTypes.string.isRequired,
};

export default BranchLocationMapView;
